import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GeneralMetricsCardSkeleton = () => (
  <Styles.Container>
    <Styles.GridContainer>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width="100%" height={76} />
      ))}
    </Styles.GridContainer>
    <Styles.GridContainer>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width="100%" height={76} />
      ))}
    </Styles.GridContainer>
  </Styles.Container>
)

export default GeneralMetricsCardSkeleton
